<template>
  <div class="pt-3">
    <div class="d-flex justify-center pa-3" v-if="dataSet">
      <div class="_temp_list">
        <div v-if="role != 'SCHOLAR'">
          <v-card class="rounded-lg mb-3" elevation="1">
            <v-img src="../../assets/img/Cover Profile Networking.png"></v-img>
            <div class="pa-3 d-flex">
              <v-avatar width="150px" height="150px" style="margin-top: -100px">
                <img
                  class="obj_fit"
                  :src="
                    dataSet.foto
                      ? dataSet.foto.foto_two
                        ? dataSet.foto.foto_two
                        : ava
                      : ava
                  "
                />
              </v-avatar>
              <div class="ml-3">
                <h2>{{ dataSet.name }}</h2>
              </div>
            </div>
          </v-card>
          <v-row>
            <v-col cols="12" md="5">
              <v-card class="pa-3 rounded-lg">
                <h3>About</h3>
                <p class="mb-0" v-if="dataSet.about" v-html="dataSet.about"></p>
                <p class="mb-0 default_txt" v-else>
                  Scholar hasn't added info about himself yet
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" md="7">
              <v-card class="pa-3 mb-3 rounded-lg">
                <h3 class="mb-3">Info</h3>

                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-card-account-details</v-icon>
                  <div>
                    <p class="mb-0">{{ dataSet.no_tf }}</p>
                    <p class="default_txt">TELADAN ID</p>
                  </div>
                </div>
                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-account</v-icon>
                  <div>
                    <p class="mb-0">
                      {{ dataSet.gender ? dataSet.gender : "Gender not shown" }}
                    </p>
                    <p class="default_txt">Gender</p>
                  </div>
                </div>
                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-cake-variant</v-icon>
                  <div>
                    <p class="mb-0">
                      {{ dataSet.dob ? dataSet.dob : "No Date of birth" }}
                    </p>
                    <p class="default_txt" v-if="dataSet.dob">Date Of Birth</p>
                  </div>
                </div>
              </v-card>
              <v-card class="pa-3 mb-3 rounded-lg">
                <h3 class="mb-3">Contact</h3>
                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-email</v-icon>
                  <div>
                    <p class="mb-0">
                      {{
                        dataSet.email
                          ? dataSet.email
                          : "No phone numbers to display"
                      }}
                    </p>
                    <p v-if="dataSet.email" class="default_txt">Email</p>
                  </div>
                </div>
                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-phone</v-icon>
                  <div>
                    <p class="mb-0">
                      {{
                        dataSet.phone_number
                          ? dataSet.phone_number
                          : "No phone numbers to display"
                      }}
                    </p>
                    <p class="default_txt" v-if="dataSet.phone_number">
                      Phone Number
                    </p>
                  </div>
                </div>
                <div class="d-flex align-start mb-2">
                  <v-icon class="mr-2">mdi-whatsapp</v-icon>
                  <div>
                    <p class="mb-0">
                      {{
                        dataSet.wa_number
                          ? dataSet.wa_number
                          : "No Whatsapp to display"
                      }}
                    </p>
                    <p class="default_txt" v-if="dataSet.wa_number">
                      Whatsapp
                    </p>
                  </div>
                </div>
              </v-card>
              <v-card class="pa-3 mb-3 rounded-lg">
                <h3 class="mb-3">Education</h3>
                <div v-if="dataSet.data_tsa">
                  <div class="d-flex align-start mb-2">
                    <v-avatar size="25" class="mr-2">
                      <img
                        class="obj_fit"
                        :src="
                          dataSet.data_tsa.profile_picture
                            ? dataSet.data_tsa.profile_picture
                            : ava_tsa
                        "
                      />
                    </v-avatar>
                    <div>
                      <p class="mb-0">
                        {{ dataSet.data_tsa.name }}
                      </p>
                      <p class="default_txt">University</p>
                    </div>
                  </div>
                  <div class="d-flex align-start mb-2">
                    <v-icon class="mr-2">mdi-school</v-icon>
                    <div>
                      <p class="mb-0">
                        {{ dataSet.major ? dataSet.major : "No Major to show" }}
                      </p>
                      <p class="default_txt" v-if="dataSet.major">Major</p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-start mb-2" v-else>
                  <v-icon class="mr-2">mdi-school</v-icon>
                  <p>No universities to show</p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div v-if="role == 'SCHOLAR'">
          <v-card flat class="rounded-lg" style="overflow: hidden">
            <v-img src="../../assets/img/Cover Profile Networking.png"></v-img>
              <v-card v-if="!loading && dataSet" flat class="rounded-lg mt-n5 pa-5">
                <v-row no-gutters align="center" justify="start">
                  <v-col cols="12" md="4" class="d-flex justify-center pa-2">
                    <div class="pa-2 avatar_ppl">
                      <v-avatar
                        width="150px"
                        height="150px"
                        style="margin-top: -80px"
                      >
                        <img
                          class="obj_fit"
                          :src="
                            dataSet.foto
                              ? dataSet.foto.foto_two
                                ? dataSet.foto.foto_two
                                : ava
                              : ava
                          "
                        />
                      </v-avatar>
                    </div>
                  </v-col>
                  <v-col cols="12" md="8">
                    <div class="d-flex justify-space-between align-center">
                      <h3 class="text-capitalize">{{ dataSet.name }}</h3>
                      <v-btn
                        v-if="dataSet.account.id != id"
                        color="#006341"
                        class="rounded-lg ml-3 text-capitalize"
                        dark
                        @click="toPrivateChat(dataSet)"
                      >
                        <v-icon class="mr-2">mdi-comment</v-icon>
                        <h4>Send Message</h4>
                      </v-btn>
                    </div>
                    <div class="d-flex align-center mt-2">
                      <div
                        class="rounded-xl px-2"
                        style="background-color: rgba(254, 4, 4, 0.3)"
                      >
                        <h5 style="color: #fe0404">
                          {{ dataSet.account ? 
                              dataSet.account.role ?
                                dataSet.account.role
                                : "-"
                              : "-"
                          }}
                        </h5>
                      </div>
                      <div
                        class="rounded-xl px-2 ml-2"
                        style="background-color: #c6f6d5"
                      >
                        <h5 style="color: #38a169">
                          {{ dataSet.data_tsa ? 
                              dataSet.data_tsa.name ? 
                                dataSet.data_tsa.name 
                                : "-"
                              : "-" }}
                        </h5>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters align="start" justify="end">
                  <v-col cols="12" md="8">
                    <div class="mt-2">
                      <div v-if="dataSet.about">
                        <span
                          v-if="!readMoreActivated && dataSet.about.length > 200"
                          >{{ dataSet.about.slice(0, 200) }}</span
                        >
                        <a
                          v-if="!readMoreActivated && dataSet.about.length > 200"
                          @click="activateReadMore"
                          style="color: #006341; font-weight: bold"
                        >
                          see more...
                        </a>
                        <span
                          v-if="readMoreActivated || dataSet.about.length < 200"
                          v-html="dataSet.about"
                        ></span>
                      </div>
                      <span v-if="!dataSet.about">-</span>
                      <v-row no-gutters class="mt-2">
                        <v-col cols="12" md="6" class="py-2">
                          <div class="d-flex align-center">
                            <v-icon color="#006341">mdi-email</v-icon>
                            <h4 class="ml-2" style="color: rgba(0, 0, 0, 0.6)">
                              {{ dataSet.email }}
                            </h4>
                          </div>
                        </v-col>
                        <v-col v-if="dataSet.wa_number" cols="12" md="6" class="py-2">
                          <div class="d-flex align-center">
                            <v-icon color="#006341">mdi-whatsapp</v-icon>
                            <h4 class="ml-2" style="color: rgba(0, 0, 0, 0.6)">
                              {{ 
                                !hide_column.includes('wa_number') ?  
                                  dataSet.wa_number 
                                  : "WA Number is hidden"
                              }}
                            </h4>
                          </div>
                        </v-col>
                        <v-col v-if="dataSet.major" cols="12" md="6" class="py-2">
                          <div class="d-flex align-center">
                            <v-icon color="#006341">mdi-school</v-icon>
                            <h4 class="ml-2" style="color: rgba(0, 0, 0, 0.6)">
                              {{ 
                                !hide_column.includes('major') ?
                                  dataSet.major
                                  : "Major is hidden"
                              }}
                            </h4>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
            </v-card>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "scholarProfile",
  computed: {
    ...mapState({
      banner: (state) => state.banner,
      id: (state) => state.id,
      role: (state) => state.role,
      ava: (state) => state.ava_lg,
      ava_tsa: (state) => state.ava_tsa,
    }),
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      hide_column:[],
      readMoreActivated: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let id = this.$route.params.id;
      let data = {
        path: `manage/scholar?page[number]=${1}&page[size]=${1}&filter[user_id]=${id}&include=dataTsa,account`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          if(data.data[0].hide){
            this.hide_column = JSON.parse(data.data[0].hide);
          }
          this.loading = false;
          this.dataSet = data.data[0];
          console.log(data.data[0]);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    activateReadMore() {
      this.readMoreActivated = true;
    },
    toPrivateChat(item) {
      localStorage.setItem("with", item.account.id);
      this.$router.push(`/networking/net/management-networking/private-chat`);
    },
  },
};
</script>

<style>
</style>